// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconSyrupusdc } from "../../../icons/mono/build/icon-syrupusdc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const SyrupusdcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconSyrupusdc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  SyrupusdcIcon.displayName = 'SyrupusdcIcon';
}

export default SyrupusdcIcon;